/**
 * @generated SignedSource<<76e71b35010002e9cda3088d3cb997e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PaymentOnlyPlan = "PROMO" | "UP_TO_100" | "UP_TO_200" | "UP_TO_50" | "UP_TO_UNLIMITED" | "YEARLY_UNLIMITED" | "YEARLY_UP_TO_100" | "YEARLY_UP_TO_200" | "YEARLY_UP_TO_50" | "%future added value";
export type CreateCheckoutSessionInput = {
  cancel_url?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  plan?: PaymentOnlyPlan;
  success_url?: string | null | undefined;
};
export type ProUpgradeCardCreateCheckoutSessionMutation$variables = {
  input: CreateCheckoutSessionInput;
};
export type ProUpgradeCardCreateCheckoutSessionMutation$data = {
  readonly createCheckoutSession: {
    readonly sessionId: string;
  } | null | undefined;
};
export type ProUpgradeCardCreateCheckoutSessionMutation = {
  response: ProUpgradeCardCreateCheckoutSessionMutation$data;
  variables: ProUpgradeCardCreateCheckoutSessionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateCheckoutSessionPayload",
    "kind": "LinkedField",
    "name": "createCheckoutSession",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sessionId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProUpgradeCardCreateCheckoutSessionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProUpgradeCardCreateCheckoutSessionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9bc8ad8fdcdeb56693ade938fceed6d3",
    "id": null,
    "metadata": {},
    "name": "ProUpgradeCardCreateCheckoutSessionMutation",
    "operationKind": "mutation",
    "text": "mutation ProUpgradeCardCreateCheckoutSessionMutation(\n  $input: CreateCheckoutSessionInput!\n) {\n  createCheckoutSession(input: $input) {\n    sessionId\n  }\n}\n"
  }
};
})();

(node as any).hash = "58ec35422960442b6ce220a30791e180";

export default node;
